import { useEffect, useState } from "react";
import http from "services/httpService";

function useFetchEndorsementBrief({ userplanId }) {
  const [endorsementBrief, setEndorsementBrief] = useState();
  const [loading, setLoading] = useState(true);

  const fetchEndorsementBrief = async () => {
    setLoading(true);
    try {
      const payload = {
        params: {
          userplan_id: userplanId,
        },
      };
      const { data } = await http.get(
        "business/get_endorsement_summary/",
        payload
      );
      setEndorsementBrief(data);
    } catch (err) {
      console.log({ err });
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchEndorsementBrief();
  }, []);

  return {
    loading,
    endorsementBrief,
  };
}

export default useFetchEndorsementBrief;
